/* eslint-disable @typescript-eslint/no-explicit-any */
// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

const environmentService = async () => {
  const response: Response = await fetch("../assets/config/appSettings.json");
  const settings = await response.json();
  return settings.portalAdmin;
};

export const environment: any = environmentService();
